import { COMPOSITION_LOGICAL_PIXELS_PER_MM } from './scale';

/** Match the thin CSS border design on a whole logical-pixel grid, once before output DPI. */
export function scaleBarStrokeWidthMm(
  authoredMm: number,
  logicalPixelsPerMm = COMPOSITION_LOGICAL_PIXELS_PER_MM,
): number {
  return Math.max(1, Math.floor(authoredMm * logicalPixelsPerMm + 1e-9)) / logicalPixelsPerMm;
}
